import React from "react";
import "./style.scss";
import StopContainer from "../../../../Redux/containers/StopItemContainer";

const RouteStopsList = React.memo(function QuoteList({
                                                         stops,
                                                         onStopDoubleClick,
                                                         onRemoveStopFromRouteClick,
                                                         onStopClick,
                                                         onStopHover,
                                                         onStopHoverOut,
                                                         isDraggingFromOutside,
                                                         drag,
                                                         isDragDisabled
                                                     }) {
    return stops.map((stop, index) => (
        <StopContainer index={index} key={stop.order_id}
                       stop={stop}
                       onStopDoubleClick={onStopDoubleClick}
                       onRemoveStopFromRouteClick={onRemoveStopFromRouteClick}
                       onStopClick={onStopClick}
                       onStopHover={onStopHover}
                       onStopHoverOut={onStopHoverOut}
                       isDraggingFromOutside={isDraggingFromOutside}
                       drag={drag}
                       isDragDisabled={isDragDisabled}
        />
    ));
});

export default function RouteStops({
                                       routeId,
                                       stops,
                                       onRemoveStopFromRouteClick,
                                       onStopDoubleClick,
                                       onStopClick,
                                       onStopHover,
                                       onStopHoverOut,
                                       isDraggingFromOutside,
                                       placeholder,
                                       drag,
                                       isDragDisabled
                                   }) {
    return (
        <div className="route-stops-wrapper">
            <div className={"route-stops"}>
                <RouteStopsList stops={stops}
                                onStopDoubleClick={onStopDoubleClick}
                                onRemoveStopFromRouteClick={onRemoveStopFromRouteClick}
                                onStopClick={onStopClick}
                                onStopHover={onStopHover}
                                onStopHoverOut={onStopHoverOut}
                                isDraggingFromOutside={isDraggingFromOutside}
                                drag={drag}
                                isDragDisabled={isDragDisabled}
                />
                {placeholder ?
                    <React.Fragment>
                        {placeholder}
                        {
                            isDraggingFromOutside && stops.length === 1 ?
                                placeholder
                                :
                                null
                        }
                    </React.Fragment>
                    :
                    null
                }
            </div>
            {
                isDraggingFromOutside ?
                    <div className="route-stops-drop-order">
                        שחרר כדי להוסיף
                    </div>
                    :
                    null
            }
        </div>
    );
}